import React from 'react';
import Header from './header.js';
import Home from './home.js';
import AboutUs from './about.js';
import Solar from './advantages.js';
import Projects from './project.js';
import WhyChooseUs from './whyaxis.js';
import SolarSolutions from './solar.js';
import GridComponent from './subpoints.js';
// import Installations from './install.js';
import Partners from './patner.js';
// import CustomerReviews from './review.js';
import Footer from './footer.js';
import Contact from './contact.js';
import Banner from './benifits.js';


function Index() {

  return (
    <div>
        <Header/>
        <Home/><br></br>
      <AboutUs/>
      <Solar/><br></br>
    
      <Projects/>
      <WhyChooseUs/>
      <GridComponent/> 
      <SolarSolutions/>
      {/* <Installations/> */}
      <Banner/>
      <Partners/>
      <Contact/>
      {/* <CustomerReviews/> */}
      <Footer/> 

      
   
    </div>
  );
}

export default Index;